"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSetZealCheckDto = instanceOfSetZealCheckDto;
exports.SetZealCheckDtoFromJSON = SetZealCheckDtoFromJSON;
exports.SetZealCheckDtoFromJSONTyped = SetZealCheckDtoFromJSONTyped;
exports.SetZealCheckDtoToJSON = SetZealCheckDtoToJSON;
exports.SetZealCheckDtoToJSONTyped = SetZealCheckDtoToJSONTyped;
/**
 * Check if a given object implements the SetZealCheckDto interface.
 */
function instanceOfSetZealCheckDto(value) {
    if (!('zealEmployeeCheckId' in value) || value['zealEmployeeCheckId'] === undefined)
        return false;
    return true;
}
function SetZealCheckDtoFromJSON(json) {
    return SetZealCheckDtoFromJSONTyped(json, false);
}
function SetZealCheckDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'zealEmployeeCheckId': json['zealEmployeeCheckId'],
    };
}
function SetZealCheckDtoToJSON(json) {
    return SetZealCheckDtoToJSONTyped(json, false);
}
function SetZealCheckDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'zealEmployeeCheckId': value['zealEmployeeCheckId'],
    };
}
//# sourceMappingURL=SetZealCheckDto.js.map